// Un team con `active_for_bot === false` está desactivado (flag canónico
// reutilizado en el backend). No debería aparecer como destino de transfer,
// ni en selectores de auto-asignación del bot.
const isActiveTeam = team => team?.active_for_bot !== false;

export const getters = {
  getTeams($state) {
    return Object.values($state.records)
      .filter(isActiveTeam)
      .sort((a, b) => (a.id > b.id ? 1 : -1));
  },
  // Para pantallas de gestión/admin que necesitan ver también los inactivos
  // (p.ej. Ajustes → Equipos, para poder reactivarlos).
  getAllTeamsIncludingInactive($state) {
    return Object.values($state.records).sort((a, b) => (a.id > b.id ? 1 : -1));
  },
  getTeamById: $state => id => {
    return (
      Object.values($state.records).find(
        record => String(record.id) === String(id)
      ) || {}
    );
  },
  getMyTeams($state, $getters) {
    return $getters.getTeams.filter(team => {
      const { is_member: isMember } = team;
      return isMember;
    });
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getTeam: $state => id => {
    const team = $state.records[id];
    return team || {};
  },
};
